import { createFileRoute } from "@tanstack/react-router";
import { SurveysPage } from "@/features/surveys/SurveysPage";

export const Route = createFileRoute("/_app/surveys")({ component: SurveysPage });
